import {
  CI_RELEASE_TAG_NAME,
  HOSTNAME,
  IS_DEV,
  SENTRY_ENABLED,
  TEST_HOSTNAMES,
  ignoreErrors,
} from './'

import type {BrowserOptions} from '@sentry/react'

/*
 * return development, production or any test hostname (ex. casablanca)
 */
const getEnvironment = () => {
  if (IS_DEV) return 'development'
  if (TEST_HOSTNAMES.includes(HOSTNAME)) return HOSTNAME.split('.', 1)[0]

  return 'production'
}

const getBreadcrumbData = (target: HTMLElement): Record<string, string | null> => {
  const cypressName = target.getAttribute('data-cy')
  const mboPiece = target.getAttribute('data-content-piece')
  const mboName = target.getAttribute('data-content-name')
  const label = target.innerText

  const data = {
    cypressName,
    mboName,
    mboPiece,
    label,
  }

  if (Object.values(data).some(Boolean)) return data
  if (!target.parentElement) return {}
  return getBreadcrumbData(target.parentElement)
}

export const getSentryBrowserOptions = (dsn: string, projectNumber: number, anonym = true): BrowserOptions => ({
  dsn:
    IS_DEV || TEST_HOSTNAMES.includes(HOSTNAME)
      ? `https://${dsn}@sentry.sdox.io/${projectNumber}`
      : `https://${dsn}@${HOSTNAME}/tpsty/${projectNumber}`,
  environment: getEnvironment(),
  enabled: SENTRY_ENABLED,
  release: CI_RELEASE_TAG_NAME,
  ignoreErrors,
  beforeSend: (event) => {
    if (anonym) {
      event.user = undefined
    }
    return event
  },
  beforeBreadcrumb(breadcrumb, hint) {
    try {
      const target = hint?.event?.target as HTMLElement

      breadcrumb.data = {
        ...getBreadcrumbData(target),
        ...breadcrumb.data,
      }
    } catch (error) {
      //
    }

    return breadcrumb
  },
  tracesSampler: () => {
    return 0.1
  },
})

export enum SentryTag {
  FolderSlug = 'folderSlug',
  RecordId = 'recordId',
  RecordType = 'recordType',
}
